import { getCalendarDateKey } from '../../utils/calendarDateKey';
import { canViewerSeeCareRecord } from '../../services/timeline/recordVisibility';
import { isTimelineVisibleSourceEntry } from '../../services/timeline/timelineSourceVisibility';
import {
  getCareSourceDisplayStatus,
  getCareSourceRecordedAtMillis,
  getCareSourceTimelineEntryIds,
  hasCareSourceSavedTimelineRecords,
} from './careSourceStatusModel';

const getCaptureDay = (source) => (
  getCalendarDateKey(source.sourceMetadata?.selectedLocalDate
    || source.sourceMetadata?.selectedDateKey
    || source.selectedLocalDate
    || source.selectedDate
    || source.sourceMetadata?.selectedDate)
  || getCalendarDateKey(getCareSourceRecordedAtMillis(source))
);

export const getPendingTimelineCaptures = ({
  sources = [], entries = [], childId = '', dateKey = '', viewerRole = null,
} = {}) => sources.filter((source) => {
  if (!source.id || source.childId !== childId || getCaptureDay(source) !== dateKey) return false;
  if (!isTimelineVisibleSourceEntry(source) || ['deleted', 'discarded', 'reviewed'].includes(source.status)) return false;
  if (!canViewerSeeCareRecord({ viewerRole, record: {
    ...source, visibility: source.visibility || source.sourceMetadata?.visibility,
  } })) return false;
  const entryIds = getCareSourceTimelineEntryIds(source);
  if (entries.some((entry) => entryIds.includes(entry.id)
    || [entry.sourceNoteId, entry.sourceId, entry.metadata?.sourceNoteId, entry.source?.sourceNoteId].includes(source.id))) {
    return false;
  }
  // Completed source receipts must not resurrect a Timeline entry after deletion.
  if (hasCareSourceSavedTimelineRecords(source) || entryIds.length > 0) return false;
  return getCareSourceDisplayStatus(source).label !== 'Reviewed';
});
